import { QueryClient } from "@tanstack/react-query";

/**
 * Shared QueryClient factory — the single place the app's query defaults live.
 *
 * Both entries construct their client here so behavior can't drift:
 *   - `main.tsx` (browser) makes one per page load, optionally hydrated from
 *     the prerender-embedded `__RQ_STATE__`.
 *   - `entry-server.tsx` (static prerender) makes one per rendered route,
 *     seeds it with the route's data, and dehydrates it into the HTML.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Retry once on failure — graceful for momentary network blips without
        // hammering the API on genuine 404s (fund not in DDB).
        retry: 1,
        // Don't refetch on window focus — fund data changes at most hourly.
        refetchOnWindowFocus: false,
      },
    },
  });
}
